export const predefinedWorkflows = [
  "#NEW_USER",
  "#NEW_SESSION",
  "#INVALID_ANSWER",
  "#NON_MATCHED",
  "#END_SESSION",
  "#SUPPORT",
  "#DEFAULT",
  "#BACK_TO_MENU",
];